import React from 'react'
import { Avatar, ListManager, Paginator } from '@/components'
import { Link, useParams } from 'react-router-dom'
import dateMask from '@/lib/masks/date'
import { ANIMAL_GENDER, CLINICAL_CARE_STATUS } from '@/lib/enums'
import usePageTitle from '@/hooks/usePageTitle'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import clinicalCares from '@/services/api/clinicalCares'
import useQuery from '@/hooks/useQuery'
import mapTitles from '../mapTitles'

function ListStatus({ title }) {
  usePageTitle({ title })
  const params = useParams()
  const query = useQuery()
  const { status } = params
  const { data, loading, error } = useAxiosRequest(clinicalCares.list, {
    status,
    ...query,
  })
  const titleParams = mapTitles(params.status)

  return (
    <ListManager loading={loading} count={data?.count || 0} error={error}>
      <>
        <table className="table text-small table-hover">
          <thead>
            <tr>
              <th>Solicitante</th>
              <th>Pet</th>
              <th>Clínica</th>
              <th>Prioridade</th>
              <th>Solicitado em</th>
              <th width="100px" className="text-right">
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            {Boolean(data)
              && data.rows.map((clinicalCare) => (
                <tr key={clinicalCare.id}>
                  <td>
                    <>
                      <Avatar
                        avatarSize="sm"
                        className="mr-1"
                        name={clinicalCare?.author?.fullName}
                        photoURL={clinicalCare?.author?.photoURL}
                        alt="Imagem de usuário"
                      />
                      {clinicalCare?.author?.fullName}
                    </>
                  </td>
                  <td>
                    {clinicalCare?.animal ? (
                      <>
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={clinicalCare?.animal?.name}
                          photoURL={clinicalCare?.animal?.photoURL}
                          smart={false}
                          alt="Imagem do animal"
                        />
                        {clinicalCare?.animal?.name}
                        <div>
                          <small>
                            {clinicalCare?.animal?.category?.description}
                          </small>
                          <small>
                            {' '}
                            - {ANIMAL_GENDER.t(clinicalCare?.animal?.gender)}
                          </small>
                        </div>
                        <div>
                          <small>
                            {clinicalCare?.animal?.breed?.description}
                          </small>
                        </div>
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {clinicalCare?.clinic ? (
                      <>
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={clinicalCare?.clinic?.fullName}
                          photoURL={clinicalCare?.clinic?.photoURL}
                          alt="Imagem de usuário"
                        />
                        {clinicalCare?.clinic?.fullName || '-'}
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {clinicalCare?.priority?.title
                      || clinicalCare?.priority?.description
                      || '-'}
                  </td>
                  <td>
                    <div>
                      {dateMask(clinicalCare.createdAt, {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </div>
                    <div>
                      <small
                        className={
                          CLINICAL_CARE_STATUS.class[clinicalCare.status]
                        }
                      >
                        {titleParams.title === 'Todos os atendimentos clínicos'
                          ? CLINICAL_CARE_STATUS.t(clinicalCare.status)
                          : ''}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div
                      className="d-flex align-center"
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <Link
                        to={`/app/clinical-cares/status/${params?.status}/${clinicalCare.id}`}
                        className="btn btn-action btn-sm btn-primary"
                      >
                        <i className="fas fa-eye" />
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {Boolean(data) && (
          <div className="float-right my-2">
            <Paginator paginatedList={data} />
          </div>
        )}
      </>
    </ListManager>
  )
}

export default ListStatus
